import * as Notes from '../services/Notes'

export const RECEIVE_NOTES = 'RECEIVE_NOTES'

export const upsertNote = (note) => (dispatch) => {
  return Notes.upsert(note)
}

function receiveNotes(state, notes) {
  return {
    type: RECEIVE_NOTES,
    notes,
  }
}

export const fetchUserNotes = (id) => (dispatch, getState) => {
  const state = getState()
  Notes.getByUserId(id).then((data) => dispatch(receiveNotes(state, data)))
}

export const fetchLicenseNotes = (id) => (dispatch, getState) => {
  const state = getState()
  Notes.getByLicenseId(id).then((data) => dispatch(receiveNotes(state, data)))
}

export const fetchGroupNotes = (id) => (dispatch, getState) => {
  const state = getState()
  Notes.getByGroupId(id).then((data) => dispatch(receiveNotes(state, data)))
}

export const fetchCustomerNotes = (id) => (dispatch, getState) => {
  const state = getState()
  Notes.getByCustomerId(id).then((data) => dispatch(receiveNotes(state, data)))
}

export const removeNote = (id) => (getState) => {
  return Notes.remove(id)
}
